import useSWRImmutable from 'swr/immutable';
import useSWR from 'swr';
import { createHttpAction } from '../api';
import { Service } from '../enums';
import { isFulfilledAccount } from '../utils/transaction-account';
import { TRANSACTION_ACCOUNT_WITHOUT_BALANCE, TRANSACTION_ACCOUNT_WITH_BALANCE } from '../mocks';
import { useMemo } from 'react';
export const useTransactionAccount = ({ bacNumber, withBalance, options, }) => {
    var _a;
    const accountsRequest = {
        service: Service.TAMS,
        url: '/accounts',
        settings: {
            params: { filter: `customerId eq ${bacNumber}` },
        },
    };
    const accountsMock = { data: [TRANSACTION_ACCOUNT_WITHOUT_BALANCE] };
    const key = bacNumber ? accountsRequest.url : null;
    const fetcher = () => createHttpAction(accountsRequest, accountsMock);
    const { data: customerAccounts, error: customerAccountsError, isLoading: customerAccountsLoading, mutate: customerAccountsMutate, } = useSWRImmutable(key, fetcher);
    const accountList = (customerAccounts === null || customerAccounts === void 0 ? void 0 : customerAccounts.data) || [];
    const fulfilledAccount = (_a = accountList.find((acc) => isFulfilledAccount(acc.state))) !== null && _a !== void 0 ? _a : accountList[0];
    const accountDetailRequest = {
        service: Service.TAMS,
        url: '/accounts/:accountId',
        settings: {
            pathParams: { accountId: fulfilledAccount === null || fulfilledAccount === void 0 ? void 0 : fulfilledAccount.id },
            params: { embed: 'balance' },
        },
    };
    const accountDetailMock = { data: TRANSACTION_ACCOUNT_WITH_BALANCE };
    const accountDetailKey = (fulfilledAccount === null || fulfilledAccount === void 0 ? void 0 : fulfilledAccount.id) && withBalance ? accountDetailRequest.url : null;
    const accountDetailFetcher = () => createHttpAction(accountDetailRequest, accountDetailMock);
    const { data: accountDetail, error: accountDetailError, isLoading: accountDetailLoading, mutate: accountDetailMutate, } = useSWR(accountDetailKey, accountDetailFetcher, options);
    const isMaintenance = useMemo(() => (accountDetailError === null || accountDetailError === void 0 ? void 0 : accountDetailError.status) === 503 ||
        (customerAccountsError === null || customerAccountsError === void 0 ? void 0 : customerAccountsError.status) === 503 ||
        (accountDetail === null || accountDetail === void 0 ? void 0 : accountDetail.status) === 206 ||
        (customerAccounts === null || customerAccounts === void 0 ? void 0 : customerAccounts.status) === 206, [accountDetailError, customerAccountsError, accountDetail, customerAccounts]);
    return {
        data: withBalance
            ? Object.assign(Object.assign({}, accountDetail === null || accountDetail === void 0 ? void 0 : accountDetail.data), { isMaintenance })
            : Object.assign(Object.assign({}, fulfilledAccount), { isMaintenance }),
        loading: customerAccountsLoading || accountDetailLoading,
        error: customerAccountsError || accountDetailError,
        mutate: withBalance ? accountDetailMutate : customerAccountsMutate,
    };
};
//# sourceMappingURL=useTransactionAccount.js.map